import LaunchingForm from './LaunchingForm.view';

export default LaunchingForm;
